import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import './Logo.css'

class Logo extends Component {

   

    render() {

        const { show } = this.props

        const logoStyle = {
            // opacity: show ? 1 : 0,
            transform: show ? 'translateY(0)' : 'translateY(-100px)'
        }

        return (

            <NavLink className="logo" to="/" style={logoStyle} >
                {/*<img src={LogoSrc} alt="watercolour"/>*/}

                <div className="icon">
                    <div className="circle circle-1"></div>
                    <div className="circle circle-2"></div>
                    <div className="circle circle-3"></div>
                </div>

           
            </NavLink>

        );
    }
}

export default Logo;